import { render, staticRenderFns } from "./product-detail.vue?vue&type=template&id=93a41046&scoped=true&"
import script from "./product-detail.vue?vue&type=script&lang=js&"
export * from "./product-detail.vue?vue&type=script&lang=js&"
import style0 from "./product-detail.vue?vue&type=style&index=0&id=93a41046&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a41046",
  null
  
)

export default component.exports